/**
 * Sage ship_via highlighted list.
 *
 * Why hardcoded?
 *   The `shipping_rate_headers` table (synced from `SO_ShippingRateHeader`)
 *   has 143 carrier rows — way too long for a default dropdown view. Like
 *   warehouses, the order team only uses a handful day-to-day, so we promote
 *   a small "Active" group and push the rest behind a "Show all" toggle.
 *
 * Source of truth (selection method):
 *   The codes below are the carriers that actually appeared on orders in
 *   `sage_sales_orders.ship_via` in the past 12 months, ordered by frequency
 *   (descending), truncated where the long tail (1–2 orders each) begins.
 *   All 15 entries were verified present in `shipping_rate_headers` on the
 *   production DB on 2026-04-09.
 *
 *   Frequency at time of selection (past 12 months from 2026-04-09):
 *     ESTES           85     TLD-TBD         12
 *     WC              72     XPOLOGISTICS    10
 *     SAIA            52     FERGUSON-VAN     9
 *     R&L             28     DAYTON           8
 *     PITT            24     FIVE STAR        7
 *     UPS             18     WILL CALL-RYAN   5
 *     RYAN TRANSPORT  14     KAG              5
 *     ECHO            13
 *
 *   These 15 carriers cover ~97% of recent orders. Scott can add/remove
 *   entries here without touching any component code — the dropdown's
 *   `highlighted` partitioning is driven entirely off this set.
 *
 * Maintenance:
 *   To promote a carrier to the Active group, add its `shipping_code`
 *   (uppercase) to `HIGHLIGHTED_SHIP_VIA_CODES`. To demote, remove it.
 *   Unknown codes (typed by users or returned by the API but not in any
 *   list) still work via the free-text fallback.
 */

/**
 * Set of ship_via codes (in upper-case form matching Sage's shipping_code)
 * that should appear in the "Active" group of the OrderDetailModal ship_via
 * dropdown. Everything else falls into the "Other" group.
 */
export const HIGHLIGHTED_SHIP_VIA_CODES: ReadonlySet<string> = new Set([
  'ESTES',
  'WC',
  'SAIA',
  'R&L',
  'PITT',
  'UPS',
  'RYAN TRANSPORT',
  'ECHO',
  'TLD-TBD',
  'XPOLOGISTICS',
  'FERGUSON-VAN',
  'DAYTON',
  'FIVE STAR',
  'WILL CALL-RYAN',
  'KAG',
]);

/** True if a ship_via code should be promoted to the Active dropdown group. */
export function isHighlightedShipVia(code: string): boolean {
  return HIGHLIGHTED_SHIP_VIA_CODES.has(code.trim().toUpperCase());
}
